import OSfSidebar from './index.vue';

OSfSidebar.install = app => {
  app.component(OSfSidebar.name, OSfSidebar);
};

export default OSfSidebar;
